import { message } from "antd";
import { server } from "../fetch";

export const fetchContact = async (acessToken, setLogout) => {
  try {
    const res2 = await fetch(`${server}/contact`, {
      method: "GET",
      headers: {
        "Content-Type": "application/json",
        // Authorization: `Bearer ${acessToken}`,
      },
    });
    const contact = await res2.json();
    if (res2.status == 200 || res2.status == 201) {
      return contact.data;
    }
    // if (res2.status == 401) {
    //   message.error("Your session has expired. Please reauthenticate again");
    //   return setLogout();
    // }
    return [];
  } catch (error) {

    return [];
  }
};


export const fetchContactInfo = async () => {
  try {
    const res2 = await fetch(`${server}/contact/contact-info`, {
      method: "GET",
      headers: {
        "Content-Type": "application/json"
      },
    });
    const contactInfo = await res2.json();
    if (res2.status == 200 || res2.status == 201) {
      return contactInfo.data;
    }
    return null;
  } catch (error) {
    return null;
  }
};
